				import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class StorageLocationService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('StorageLocation');
	}
	
	loadAll(active: boolean) : Observable<TooBig4Car.Logic.StorageLocation[]> {
		return this.myBaseService.loadAll(this.url + '?active=' + (active ?? true).toString());
	}
	save(tempItem: TooBig4Car.Logic.ObjectBase) : Observable<TooBig4Car.Logic.StorageLocation> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.StorageLocation> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<TooBig4Car.Logic.StorageLocation>{
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string) : Observable<TooBig4Car.Logic.StorageLocation[]>{
		return this.myBaseService.post(searchTerm, this.url + '/Search', false);
	}
}
				
